import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth";

export default function Login() {
  const { me, login } = useAuth();
  const navigate = useNavigate();
  const [company_code, setCode] = useState("");
  const [employee_id,  setEmp]  = useState("");
  const [password,     setPw]   = useState("");
  const [error,        setError] = useState("");
  const [loading,      setLoading] = useState(false);

  useEffect(() => { if (me) navigate("/portal/checkin", {replace:true}); }, [me]);
  if (me) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (!company_code.trim()) { setError("Enter your Company ID."); return; }
    setLoading(true); setError("");
    try {
      await login(company_code.toUpperCase().trim(), employee_id.toUpperCase().trim(), password);
      navigate("/portal/checkin", {replace:true});
    } catch(err) {
      setError(err.message || "Login failed.");
    } finally { setLoading(false); }
  };

  return (
    <div style={{minHeight:"100vh",display:"flex",alignItems:"center",
      justifyContent:"center",background:"var(--bg)"}}>
      <div className="card" style={{width:"100%",maxWidth:400,padding:"36px 32px"}}>
        <div style={{textAlign:"center",marginBottom:28}}>
          <div style={{fontSize:13,fontWeight:700,letterSpacing:".2em",
            color:"var(--muted)",marginBottom:4}}>INVINCIBLE · HR</div>
          <h1 style={{fontSize:24,fontWeight:700}}>Employee Portal</h1>
          <p style={{fontSize:13,color:"var(--muted)",marginTop:4}}>
            Invincible Web Solutions LLP
          </p>
        </div>

        <form onSubmit={submit}>
          <div style={{marginBottom:14}}>
            <label>Company ID</label>
            <input className="inp" value={company_code}
              onChange={e=>setCode(e.target.value)} required
              placeholder="e.g. IWS, ACME"
              style={{textTransform:"uppercase",letterSpacing:".08em",fontWeight:600}}/>
            <div style={{fontSize:11,color:"var(--muted)",marginTop:4}}>
              Provided by your admin
            </div>
          </div>
          <div style={{marginBottom:14}}>
            <label>Employee ID</label>
            <input className="inp" value={employee_id}
              onChange={e=>setEmp(e.target.value)} required
              placeholder="e.g. IWS001"/>
          </div>
          <div style={{marginBottom:20}}>
            <label>Password</label>
            <input className="inp" type="password" value={password}
              onChange={e=>setPw(e.target.value)} required/>
          </div>
          {error && (
            <div style={{color:"var(--danger)",fontSize:13,marginBottom:14,
              padding:"10px 12px",background:"#FEE2E2",borderRadius:8}}>
              {error}
            </div>
          )}
          <button className="btn full" type="submit" disabled={loading}
            style={{opacity:loading?.7:1}}>
            {loading ? "Signing in…" : "Sign in →"}
          </button>
        </form>

        <div style={{textAlign:"center",marginTop:20,fontSize:12,color:"var(--muted)"}}>
          Powered by Invincible Web Solutions LLP
        </div>
      </div>
    </div>
  );
}
